module.exports = __webpack_public_path__ + "img/c08_unittechvimanachampion_Normal_ua.462a08b4.webp";